export default __webpack_public_path__ + "static/media/helpicon.99417773.svg";